import clike from "refractor/clike";
export default clike;